import {Divider} from './Divider.styled';

export default Divider;
